import script from "./FileUploadDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUploadDialog.vue?vue&type=script&setup=true&lang=ts"

import "./FileUploadDialog.vue?vue&type=style&index=0&id=7d96a79d&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d96a79d"]])

export default __exports__